import { Popover as PopoverComponent } from '@lokalise/louis';
import { type FC, type ReactNode } from 'react';

import { projectUrlWithParams } from '../../../../../../routes';
import type { BuiltinFilters, ProjectDisplayQaIssues } from '../../../../../../types/project';
import { qaIssueFilterMap, qaIssueNameMap } from '../../../../../ProjectsList/components/ProjectQaIssues';
import { Item, List, Trigger } from './styles';

const prepareData = (
    issues: Partial<ProjectDisplayQaIssues>,
): {
    label: string;
    value: number;
    filter: BuiltinFilters;
}[] => {
    const entries = Object.entries(issues);

    return entries.map(([qaStatisticName, value]) => ({
        label: qaIssueNameMap[qaStatisticName as keyof Partial<ProjectDisplayQaIssues>],
        value,
        filter: qaIssueFilterMap[qaStatisticName as keyof Partial<ProjectDisplayQaIssues>],
    }));
};

interface QaPopoverProps {
    issues: Partial<ProjectDisplayQaIssues>;
    projectId: string;
    children: ReactNode;
}

const QaPopover: FC<QaPopoverProps> = ({ children, issues, projectId }) => {
    const data = prepareData(issues);

    return (
        <PopoverComponent
            withArrow
            content={
                <List>
                    {data.map(({ filter, value, label }) => (
                        <Item key={filter}>
                            {label} <a href={projectUrlWithParams({ projectId, filter })}>{value}</a>
                        </Item>
                    ))}
                </List>
            }
        >
            <Trigger>{children}</Trigger>
        </PopoverComponent>
    );
};

export default QaPopover;
